var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    { class: _vm.classList },
    [
      _c("input", {
        staticClass: "switch-input",
        attrs: { type: "checkbox" },
        domProps: { value: _vm.value, checked: _vm.isChecked },
        on: { change: _vm.handleChange }
      }),
      _vm._v(" "),
      _vm.isOn
        ? [
            _c("span", {
              staticClass: "switch-label",
              attrs: { "data-on": _vm.on, "data-off": _vm.off }
            })
          ]
        : [_c("span", { staticClass: "switch-label" })],
      _vm._v(" "),
      _c("span", { staticClass: "switch-handle" })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a4bc38b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4bc38b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/Switch.vue
// module id = 1564
// module chunks = 1